/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function formRequest(value) {
  const rootUrl = Shopify?.routes?.root || Shopify?.routes?.rootUrl;
  return fetch(rootUrl + 'products/' + value + '?view=boost-sd-integration').then(response => response.text()).catch((error) => console.error(error))
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
          name: 'ProductItem - call get Products Data',
          apply() {
              return {
                   afterRender(element) {
                      const productData = element.getParams().props.product;
                      if (!productData) {
                          return
                      }

                      const productId = productData.id;
                      const productHandle = productData.handle;
                      const variantId = productData.variants?.find((_, index) => index <= 1)?.id || undefined

                      const productBoostElm = document.querySelector('[data-product-id="' + productId + '"]');
                      if (!productBoostElm) {
                          return
                      }

                      const isCollectionGift = !!document.querySelector('.collection.gift')

                      // Add to Cart button
                      if (!productBoostElm.querySelector('.container__add-to-cart') && variantId && !isCollectionGift) {
                        const imageContainer = productBoostElm.querySelector('.boost-sd__product-link-image')

                        const btnAddToCart = `
                          <div class="container__add-to-cart lg:hidden px-4">
                            <button
                              type="button"
                              class="button primary whitespace-nowrap"
                              @click.prevent.debounce="
                                () => {
                                  $store.cart.add(${variantId}, 1);
                                }
                              ">
                              Add To Cart
                            </button>
                          </div>
                        `

                        imageContainer.insertAdjacentHTML('beforeend', btnAddToCart);
                      }
                     
                      // Gift Now button
                      if (!productBoostElm.querySelector('.container__gift-now') && isCollectionGift) {
                        // const imageContainer = productBoostElm.querySelector('.boost-sd__product-item')

                        const btnGiftNow = `
                          <div class="container__gift-now m-md:mx-auto m-md:px-4">
                            <a
                              class="button primary whitespace-nowrap desktop-button"
                              href="/products/${productHandle}/"
                            >
                              Gift Now
                              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18" fill="none">
                                <path d="M1 8.63158H30C27.7692 8.12281 22.6385 5.88421 19.9615 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 8.63157H30C27.7692 9.14035 22.6385 11.3789 19.9615 16.2632" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </a>
                             <a
                              class="button quinary mobile-button"
                              href="/products/${productHandle}/"
                            >
                              View Details
                              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="14" viewBox="0 0 31 18" fill="none">
                                <path d="M1 8.63158H30C27.7692 8.12281 22.6385 5.88421 19.9615 1" stroke="#dd8ba6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 8.63157H30C27.7692 9.14035 22.6385 11.3789 19.9615 16.2632" stroke="#dd8ba6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </a>
                          </div>
                        `

                        const avgRating = productData.metafields?.find(metafield => metafield.key === 'avg_rating')?.value
                        const numReviews = productData.metafields?.find(metafield => metafield.key === 'num_reviews')?.value
                        if (avgRating && numReviews) {
                          const rating = `
                            <div class="boost-sd__product-reviews">
                              <div 
                                class="loox-rating" 
                                data-id="${productId}" 
                                data-rating="${avgRating}" 
                                data-raters="${numReviews}">
                              </div>  
                            </div>
                          `

                          productBoostElm.querySelector('.boost-sd__product-info')?.insertAdjacentHTML('beforeend', rating);
                        }

                        productBoostElm.insertAdjacentHTML('beforeend', btnGiftNow);
                      }

                      // Hide second image
                      if (!productBoostElm.querySelector('.hide-second-image') && productData.tags.includes('hide-second-image')) {
                        const secongImageElm = productBoostElm.querySelector('.boost-sd__product-image-img--second')
                        if (secongImageElm) {
                          secongImageElm.classList.add('hide-second-image')
                        }
                      }

                      // Bundle promo banner
                      if (!document.querySelector('.bundle-promo-banner')) {
                        const newDiv = document.createElement('div');
                        newDiv.innerHTML = `
                          <div style="height: 490px; border-radius: 22px;background: #E6EEFC; box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);" class="bundle-promo-banner relative w-full overflow-hidden md:hidden">
                            <img class="absolute inset-0 w-full h-full" src="https://cdn.shopify.com/s/files/1/0558/2641/5809/files/collection-bundle-banner.png" alt="bundle banner" />
                            <a 
                              href="${window.Shopify.buildABox.bundleUrl}" 
                              style="position: absolute; left: 50%; bottom: 20px; transform: translateX(-50%); z-index: 5; width: 100%; max-width: 210px; whitespace: no-wrap;"
                              class="btn primary" aria-label="Build a Box"
                            >Build a Box</a>
                          </div>
                        `

                        document.querySelector('.boost-sd__filter-tree-vertical-content').appendChild(newDiv);
                      }

                  },
              };
          },
      });
  }
]);